require('./formEditorNav.i18n.json');
require('./formEditorNavController.js');
require('./formEditorNav.tpl.html');

const FormEditorNavComponent = {
    templateUrl: '/configuration/formEditor/nav/formEditorNav.tpl.html',
    controller: 'formEditorNavController',
    bindings: {}
};

angular.module('ums')
    .component('uiFormEditorNav', FormEditorNavComponent);
